import { Pill } from '@clearcover/atlas';
import React, { FC } from 'react';

type UserStatusPillProps = {
  activated: boolean;
};

export const UserStatusPill: FC<UserStatusPillProps> = ({ activated }) => (
  <Pill variant={activated ? 'success' : 'disabled'}>
    {activated ? 'Activated' : 'Deactivated'}
  </Pill>
);
